import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle } from "@phosphor-icons/react";

/**
 * Uniforme "Test afsluiten" knop voor onderaan elke testpagina,
 * zichtbaar zodra de test in voltooide staat is. Navigeert terug
 * naar het tests-overzicht.
 */
export default function TestCloseButton({ testId = "test-close-btn", label = "Test afsluiten" }) {
  return (
    <div className="pt-6 mt-6 border-t border-zinc-200 flex justify-center">
      <Link
        to="/tests"
        data-testid={testId}
        className="inline-flex items-center gap-2 bg-zinc-900 text-white px-6 py-3 text-sm font-semibold tracking-wide uppercase rounded-sm hover:bg-[#1E88E5] transition-colors shadow-sm"
      >
        <CheckCircle size={18} weight="bold" /> {label}
      </Link>
    </div>
  );
}
